<template>
  <div class="col col-12 pa-0 input-form">
    <span v-if="field.title" class="label"><b>{{ $t(field.title) }}</b><span v-if="field.props && field.props.required"
        style="color:red">&nbsp;*</span></span>
    <v-menu v-model="modal" allow-overflow min-width="auto" min-height="auto" :close-on-content-click="false" offset-y
      style="flex-shrink:0; flex-grow:0;">
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on" @click="modal = true" style="width:48%;">
          <v-text-field solo dense readonly validate-on-blur :props="field.props" :rules="[validate]"
            ref="textareaDate" flat v-model="dateComputed" class="pt-0 mt-0"
            style="min-height:38px; flex-shrink:0; flex-grow:0;" :label="$t('dateLabel')">
            <template v-slot:prepend-inner>
              <v-icon small color="primary">
                $calendar_d
              </v-icon>
            </template>
          </v-text-field>
        </span>
      </template>
      <v-card class="width:auto; ">
        <v-card-text>
          <vc-date-picker :attributes="attributes" @dayclick="onDayClick" :value="null" :minDate="minDate" :maxDate="maxDate"  :model-config="modelConfig" ref="rangePicker" class="pa-2"
            style="background-color:transparent; border:none;" :key="'calendar_' + this.fieldName + '_' + this.calendarKey" />
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import validate from '../functions/validations'
import { format, parse } from 'date-fns'
import dateManipulation from '@/mixins/dateManipulation'
import infoTooltip from '@/components/infoTooltip';

const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
const DEFAULT_SHOWING_FORMAT = 'dd/MM/yyyy';
const DEFAULT_RETURN_FORMAT = 'yyyy-MM-dd';

export default {
  props: ["model", "fieldName", "field"],
  components: { infoTooltip },
  mixins: [validate, dateManipulation],
  data() {
    return {
      days : [],
      datePickerProps: {},
      modal: false,
      date: '',
      minDate: "",
      maxDate: "",
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD', // Uses 'iso' if missing
      },
      calendarKey: 0
    };
  },
  created() {
    let datePickerProps = {
      locale: this.lang
    };

    if (this.field && this.field.props && this.field.props.datePickerProps && this.field.props.datePickerProps.minDateDependField && this.model[this.field.props.datePickerProps.minDateDependField]) {
      this.minDate = this.model[this.field.props.datePickerProps.minDateDependField]
    }
    if (this.field && this.field.props && this.field.props.datePickerProps && this.field.props.datePickerProps.maxDateDependField && this.model[this.field.props.datePickerProps.maxDateDependField]) {
      this.maxDate = this.model[this.field.props.datePickerProps.maxDateDependField]
    }
    if (this.field && this.field.props && this.field.props.datePickerProps) {
      this.datePickerProps = Object.assign({}, datePickerProps, this.field.props.datePickerProps);
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    model: {
      deep: true,
      handler(val, oldval) {
        if (this.field && this.field.props && this.field.props.datePickerProps && this.field.props.datePickerProps.minDateDependField && this.model[this.field.props.datePickerProps.minDateDependField]) {
          this.minDate = this.model[this.field.props.datePickerProps.minDateDependField]
        }
        if (this.field && this.field.props && this.field.props.datePickerProps && this.field.props.datePickerProps.maxDateDependField && this.model[this.field.props.datePickerProps.maxDateDependField]) {
          this.maxDate = this.model[this.field.props.datePickerProps.maxDateDependField]
        }
        if (this.field && this.field.props && this.field.datePickerProps ) {
          this.datePickerProps = Object.assign({}, datePickerProps, this.field.props.datePickerProps);
        }
        this.calendarKey++;
      }
    }
  },
  methods: {
    init() {
      if (!this.model[this.fieldName]) {
        return;
      } else {
        this.days = this.model[this.fieldName].map(day => {
          return {
            id: day,
            date: new Date(day),
          }
        });
      }

    
      // if (this.model[this.fieldName] instanceof Date) {
      //   initDate = this.model[this.fieldName];
      // } else if (typeof this.model[this.fieldName] === 'string' || this.model[this.fieldName] instanceof String) {
      //   initDate = new Date(this.model[this.fieldName])
      // }

      // this.date = format(initDate, DEFAULT_DATE_FORMAT);
    },
    onDayClick(day) {
      const idx = this.days.findIndex(d => d.id === day.id);
      if (idx >= 0) {
        this.days.splice(idx, 1);
      } else {
        this.days.push({
          id: day.id,
          date: day.date,
        });
      }
      this.$set(this.model, this.fieldName, this.days.map(day => day.id));
      this.calendarKey++
    },
  },
  computed: {
    dates() {
      return this.days.map(day => day.date);
    },
    attributes() {
      return this.dates.map(date => ({
        highlight: true,
        dates: date,
      }));
    },
    dateComputed: {
      get: function () {
        return this.days.map(day => this.parseUsDateToFr(this.parseJsDateToUs(day.date)));
      }
    },
    lang() {
      if (this.$store.state.auth.currentUser.parameters.lang) {
        return this.$store.state.auth.currentUser.parameters.lang
      } else {
        return this.$store.state.auth.currentUser.profile.lang
      }
    }
  }
};
</script>

<style lang="scss">
.v-application--is-ltr .v-text-field .v-input__prepend-inner {
  padding-right: 15px;
}
</style>